module.exports = __webpack_public_path__ + "img/background-arch.90a37034.jpg";